export class EEventKiwidSocket {
    static readonly CONNECT = 'connect';
    static readonly CONNECT_ERROR = 'connect_error';
    static readonly DISCONNECT = 'disconnect';
    static readonly ERROR = 'error';
    static readonly EXCEPTION = 'exception';
    static readonly REFRESH_TOKEN = (refreshToken: string) => `refresh-token/${refreshToken}`;
    // NOTIFICATION MESSAGE
    static readonly NOTIFICATION_MESSAGE_BADGE = 'clinic/notification/message/badge';
    static readonly NOTIFICATION_MESSAGE_MARK_READ = 'clinic/admin/notification/message/mark-read';
    static readonly NOTIFICATION_MESSAGE_JOIN_BADGE = 'clinic/admin/notification/message/join-badge';
    static readonly NOTIFICATION_MESSAGE_LEAVE_BADGE = 'clinic/admin/notification/message/leave-badge';
    static readonly NOTIFICATION_MESSAGE_GET_ALL = 'clinic/admin/notification/message/get-all';
    // CLINIC MESSAGE
    static readonly CLINIC_MESSAGES = 'clinic-message/messages';
    static readonly CLINIC_MESSAGE_JOIN_ROOM = 'clinic/admin/clinic-message/join-room';
    static readonly CLINIC_MESSAGE_LEAVE_ROOM = 'clinic/admin/clinic-message/leave-room';
    static readonly CLINIC_MESSAGE_GET_ALL = 'clinic/admin/clinic-message/get-all';
    static readonly CLINIC_MESSAGE_CREATE = 'clinic/admin/clinic-message/create';
    // CLINIC CHAT
    static readonly CLINIC_CHAT_JOIN_ROOM = 'clinic/admin/clinic-chat/join-room';
    static readonly CLINIC_CHAT_LEAVE_ROOM = 'clinic/admin/clinic-chat/leave-room';
    static readonly CLINIC_CHAT_CREATE_MESSAGE = 'clinic/admin/clinic-chat/create-message';
    static readonly CLINIC_CHAT_MESSAGES = 'clinic-chat/messages';
}
